import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=4f5d83ef&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=ts"
export * from "./SupplierList.vue?vue&type=script&lang=ts"
import style0 from "./SupplierList.vue?vue&type=style&index=0&id=4f5d83ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d83ef",
  null
  
)

export default component.exports